module.exports = __webpack_public_path__ + "static/media/carrotlogoorange.d61c326f.svg";